import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import Box from 'components/Box';
import Stack from 'components/Stack';
import Text from 'components/Text';
function ShareWithEveryoneWidget() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "h3",
    overflow: "wrap"
  }, t('advanced_audience_widget_audience_colon'))), /*#__PURE__*/React.createElement(Box, {
    background: "shaded",
    borderRadius: "small",
    px: "s",
    py: "xs"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "p",
    size: "small"
  }, t('state_everyone_with_access'))));
}
export default ShareWithEveryoneWidget;